import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import PageLayout from '../components/PageLayout';
import './Portfolio.css';

const Portfolio = () => {
  const portfolioItems = [
    {
      id: 'software',
      title: 'Software Development',
      description: 'Custom software development services delivering innovative solutions.',
      link: '/portfolio/software-development',
      image: 'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.1.0',
      category: 'Technology'
    },
    {
      id: 'cyber',
      title: 'Cyber Security',
      description: 'Advanced cybersecurity solutions with AI and ML-powered security intelligence tools.',
      link: '/portfolio/cybersecurity',
      image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0',
      category: 'Technology'
    },
    {
      id: 'trading',
      title: 'Blockchain and Crypto',
      description: 'Advanced blockchain technologies and cryptocurrency trading solutions.',
      link: '/portfolio/blockchain-seed-investment',
      image: 'https://images.unsplash.com/photo-1639762681485-074b7f938ba0?q=80&w=2032&auto=format&fit=crop&ixlib=rb-4.1.0',
      category: 'Technology'
    },
    {
      id: 'electronic',
      title: 'Electronic Intrusion Detection',
      description: 'Advanced electronic intrusion detection sensors and monitoring systems.',
      link: '/portfolio/intrusion-detection',
      image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0',
      category: 'Technology'
    },
    {
      id: 'education',
      title: 'Techucation',
      description: 'Educational technology solutions combining traditional learning with modern tools.',
      link: '/portfolio/education',
      image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?q=80&w=2122&auto=format&fit=crop&ixlib=rb-4.1.0',
      category: 'Education'
    },
    {
      id: 'health',
      title: 'Biotech & Longevity',
      description: 'Investment in biotechnology and longevity research innovations.',
      link: '/portfolio/biotech',
      image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0',
      category: 'Healthcare'
    },
    {
      id: 'immigration',
      title: 'Immigration Services',
      description: 'Comprehensive immigration solutions and legal services for individuals and businesses.',
      link: '/portfolio/immigration',
      image: '/images/globe1.png',
      category: 'Legal Services'
    },
    {
      id: 'corporate',
      title: 'Corporate Services',
      description: 'Strategic business consulting and corporate advisory services.',
      link: '/portfolio/corporate-services',
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0',
      category: 'Business'
    },
    {
      id: 'event',
      title: 'Business Advisory',
      description: 'Strategic business consulting and financial advisory services.',
      link: '/portfolio/event',
      image: 'https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0',
      category: 'Business'
    },
    {
      id: 'art',
      title: 'Emirati & Contemporary Art',
      description: 'Contemporary art gallery featuring innovative artistic expressions.',
      link: '/portfolio/art',
      image: '/images/mrk-art-gallery.png',
      category: 'Arts'
    }
  ];

  const categories = ['All', 'Technology', 'Healthcare', 'Business', 'Legal Services', 'Education'];

  return (
    <PageLayout 
      title="Our Portfolio" 
      subtitle="Discover our diverse range of investments and business ventures across multiple industries"
    >
      <section className="portfolio-section">
        <div className="container">
          <div className="portfolio-intro">
            <h2>Diversified Investments</h2>
            <p>
              Since 1994, we have built a comprehensive portfolio spanning technology, healthcare, 
              education, and business services. Our strategic investments focus on innovative 
              solutions that create lasting value and drive meaningful change.
            </p>
          </div>

          <div className="portfolio-grid">
            {portfolioItems.map((item) => (
              <div key={item.id} className="portfolio-card">
                <div className="portfolio-image">
                  <img src={item.image} alt={item.title} />
                  <div className="portfolio-overlay">
                    <span className="portfolio-category">{item.category}</span>
                  </div>
                </div>
                <div className="portfolio-content">
                  <h3 className="portfolio-title">{item.title}</h3>
                  <p className="portfolio-description">{item.description}</p>
                  <a href={item.link} className="portfolio-link">
                    Explore Service
                    <span className="link-arrow">→</span>
                  </a>
                </div>
              </div>
            ))}
          </div>
          
        </div>
      </section>
    </PageLayout>
  );
};

export default Portfolio;